import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "AccountBalanceLimit"
}

import UiIcon from "@/plugins/ui/components/icon/UiIcon.vue";
import UiSubhead from "@/plugins/ui/components/typography/UiSubhead.vue";
import { useAsync } from "@/use/useAsync";
import { useScore } from "@/use/useScore";
import { formatCurrency } from "@/utils";


export default /*#__PURE__*/_defineComponent({
  __name: 'AccountBalanceLimit',
  setup(__props) {

const { limit, fetchLimit } = useScore();

useAsync(fetchLimit, true);

return (_ctx: any,_cache: any) => {
  return (_unref(limit).limit > -1)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(UiIcon, {
          type: "solid",
          icon: "Exclamation"
        }),
        _createVNode(UiSubhead, {
          weight: "semibold",
          class: "AccountBalanceLimit__value"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Установлен лимит " + _toDisplayString(_unref(formatCurrency)(_unref(limit).limit / 100)), 1)
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}
}

})